import React, { SVGProps } from 'react';

const CloseIcon: React.FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="21"
    viewBox="0 0 20 21"
    fill="none"
    {...props}
  >
    <path
      d="M5.05027 5.50045L10 10.4502M10 10.4502L14.9498 15.3999M10 10.4502L14.9498 5.50045M10 10.4502L5.05027 15.3999"
      stroke="#1F2937"
      strokeWidth="1.5"
    />
  </svg>
);

export default CloseIcon;
